module.exports = __webpack_public_path__ + "static/img/03.76b3ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/03.png
// module id = z7Tu
// module chunks = 64